module.exports = __webpack_public_path__ + "img/nav-casa.afa842d1.svg";